import React, { useEffect } from "react";
import styles from "./event.module.css";
import { ReactComponent as HighIcon } from "../../../assets/icons/event/high.svg";
import { ReactComponent as MidIcon } from "../../../assets/icons/event/mid.svg";
import { ReactComponent as InfoIcon } from "../../../assets/icons/event/info.svg";
import { ReactComponent as AssistCart } from "../../../assets/icons/event/buttons/assist.svg";
import { ReactComponent as MissedCall } from "../../../assets/icons/event/missedCall.svg";
import BusAlertIcon from '@mui/icons-material/BusAlert';
import BottomActions from "./bottomActions";
import common_types from "../../../common_files/common_types";

const EVENT_TYPES = common_types.event_type_enum;
const EVENT_SEVERITY_ENUM = common_types.event_severity_enum;

const highString = EVENT_SEVERITY_ENUM.SEVERITY_HIGH;
const midString = EVENT_SEVERITY_ENUM.SEVERITY_MEDIUM;
const lowString = EVENT_SEVERITY_ENUM.SEVERITY_LOW;

const EventIconsEnum = {}
EventIconsEnum[highString] = <HighIcon />;
EventIconsEnum[midString] = <MidIcon />;
EventIconsEnum[lowString] = <InfoIcon />;

const newEventsIconsEnum = {
  system: {
    [lowString]:  <InfoIcon style={{ color: "#b0bec5", fontSize: 28 }} />,
    [midString]:  <MidIcon  style={{ color: "#ffb300", fontSize: 28 }} />,
    [highString]: <HighIcon style={{ color: "#e53935", fontSize: 28 }} />,
  },
  user: {
    [lowString]:  <InfoIcon style={{ color: "#b0bec5", fontSize: 28 }} />,
    [midString]:  <MidIcon  style={{ color: "#ffb300", fontSize: 28 }} />,
    [highString]: <HighIcon style={{ color: "#e53935", fontSize: 28 }} />,
  },
  cart: {
    [lowString]:  <BusAlertIcon style={{ color: "#b0bec5", fontSize: 24 }} />,
    [midString]:  <BusAlertIcon style={{ color: "#ffb300", fontSize: 24 }} />,
    [highString]: <BusAlertIcon style={{ color: "#e53935", fontSize: 24 }} />,
  }
};


export default function EventItem({
    event,
    resolveEvent,
    focusOnCart,
    callBack,
    assistCart,
    openCamerasModal,
    openRecorderModal,
}) {
  
    // --- Encapsulated Event Details ---
    let openTime = new Date(event.open_date_time);
    const eventId = event.eventId;
    const userId = event.user_id || null;
    const cartId = event.cart_id || null;
    const eventName = event.name || null;
    const eventType = event.event_type || null;
    const eventSeverity = event.severity || null;
    let minStr = (openTime.getMinutes() < 10 ? '0' : '') + openTime.getMinutes();
    let houStr = (openTime.getHours() < 10 ? '0' : '') + openTime.getHours();
    const formattedTime = `${houStr}:${minStr}`;
    const tip = event.tip || "";
    const details = event.details || "";
    const subject = event.subject || "";
    const subtype = event.subtype || "";
    const operationOptionsList = event.operation_options_list || [];
    let data = event.data || null; // to remove
    // let blockedImg = event && event.blockedImg ? event.blockedImg : null; // ??????????????

    const isCartEvent = eventType &&
    (eventType === EVENT_TYPES.TYPE_SYSTEM_ISSUE ||
     eventType === EVENT_TYPES.TYPE_OPERATOR_TREATMENT ||
     eventType === EVENT_TYPES.TYPE_UNAVAILABLE ||
     eventType === EVENT_TYPES.TYPE_PATH_STUCK ) ? true : false;

    // const isCartResolvableEvent = isCartEvent && // add an event type for - post proccess event

    const isUserEvent = eventType &&
    (eventType === EVENT_TYPES.MISSED_CALL_EVENT ||
     eventType === EVENT_TYPES.CART_UNAVAILABILITY_EVENT) ? true : false

    const isSystemEvent = eventType && 
    (eventType === EVENT_TYPES.GENERAL_EVENT) ? true : false
    let isMissedCalledEvent = eventType === EVENT_TYPES.MISSED_CALL_EVENT;
    
    const [hover, setHover] = React.useState(false);
    const closeEvent = () => setHover(false);
    
    
    const currentEventTypeName = isUserEvent ? 'user' :
                             isCartEvent ? 'cart' :
                             isSystemEvent ? 'system' : null;
                                 
    let icon = isMissedCalledEvent ? <MissedCall /> : newEventsIconsEnum[currentEventTypeName][eventSeverity];

    /// define body text ///
    const bodyText = (
      <div className={styles.bodyTextContainer}>
        <div className={styles.bodyTextRow}>
          <span className={styles.label}>Instructions:</span>
          <span className={styles.value}>{tip}</span>
        </div>
      </div>
    );
    
    
    return (
        <div onClick={() => setHover(!hover)}>
          {hover ? (
            <div className={styles.event_item_open}>

              <div className={styles.event_item_close}>
                <span className={styles.event_item_close_icon}>{icon}</span>
                <span className={styles.event_item_close_title}>                
                {isCartEvent && `Cart ${cartId}`}
                {isUserEvent && `User ${eventName}`}
                {isSystemEvent && `Site Event ${eventName}`}
                </span>
                <span className={styles.event_item_close_time}>{formattedTime}</span>
              </div>

              <div className={styles.event_item_open_body_header}>
                {eventName === 'System' ? 'Site System' : eventName}
              </div>

              <div className={styles.event_item_open_body_text}>

                {isMissedCalledEvent && event.counter > 0 ?
                (
                  <span>
                    Tried calling <b>{event.counter}</b> times.
                  </span>
                ) : (
                  <div className="black-scroll-bar-container" style={{ minHeight: "30px" }}>
                    {bodyText}
                  </div>
                )}
              </div>

              <BottomActions
                event_type={eventType}
                eventSubtype={subtype}
                eventId={eventId}
                resolveEvent={resolveEvent}
                cartId={isCartEvent ? cartId : null}
                focusOnCart={focusOnCart}
                callBack={callBack}
                userId={userId}
                eventName={eventName}
                isCartEvent={isCartEvent}
                
                operationOptionsList={operationOptionsList}
                openCamerasModal={openCamerasModal}
                openRecorderModal={openRecorderModal}
              />
            </div>
          ) : (
            <div className={styles.event_item_close}>
              <span className={styles.event_item_close_icon}>{icon}</span>
              <span className={styles.event_item_close_title}>
                {isCartEvent && `Cart ${event.cart_id}`}
                {isUserEvent && `User ${event.name}`}
                {isSystemEvent && `Site Event ${event.name}`}
              </span>
              <span className={styles.event_item_close_time}>{formattedTime}</span>
            </div>
          )}
        </div>
      );
}